import { useUserBoostedFarmsInfos } from 'state/farmBoost/useUserBoostedFarmsInfos'
import { useCallback } from 'react'

const useInvalidateBoostedFarms = () => {
  const invalidatingBoostedFarms = useCallback(() => {
    useUserBoostedFarmsInfos.getState().refresh()
  }, [])

  return { onInvalidatingBoostedFarms: invalidatingBoostedFarms }
}

export default useInvalidateBoostedFarms
